
/***
 * GERAL
 ***/
$(function() {
    $('.animsition').animsition().one('animsition.inStart',function(){
        App.SetToggle();
        App.SetGaleria();
        App.SetBanner();
        App.SetCarouselMobile();
        App.SetHeaderFixed(80);
        App.SetValidate();
        App.SetMaskInput();
        App.SetInputError();
        App.SetFormSuccess();
        App.SetAnimatescroll(150);
        App.SetWow(200);

        $('html').addClass('loaded');

        // Carousel depoimentos
        $('[data-component=carousel-depoimentos]').each(function(index, el) {
            $(this).addClass('owl-carousel');
            $(this).owlCarousel({
                loop            : true,
                items           : 3,
                autoplay        : false,
                autoplayTimeout : 7000,
                animateOut      : 'fadeOut',
                dots            : true,
                navText         : ['<i class="icon-left"></i>', '<i class="icon-right"></i>'],
                margin          : 15,
                responsive      : {
                    0: {
                        items: 1,
                        nav: true,
                        center: true,
                        autoHeight: true,
                        autoplay : true,
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    }
                }
            });
        });

        // Carousel galeria home
        $('[data-component=galeria-home]').each(function(index, el) {
            $(this).addClass('owl-carousel');
            $(this).owlCarousel({
                loop            : true,
                items           : 2,
                autoplay        : false,
                autoplayTimeout : 6000,
                animateOut      : 'fadeOut',
                dots            : true,
                margin          : 15,
                responsive  : {0:{items : 1},769:{items : 2}},
            });
        });

        // Tabs
        $('[data-component=tabs]').each(function(index, el) {
            $(el).on('click', '.list a', function(event) {
                event.preventDefault();
                var href   = $(this).attr('href');

                $('.list a').removeClass('_active');
                $('.tabs .tab').removeClass('_active');

                $('.list a[href='+href+']').addClass('_active');
                $(href).addClass('_active');
            });
        });

        // Carousel blog
        $('[data-component=carousel-blog]').each(function(index, el) {
            $(this).addClass('owl-carousel');
            $(this).owlCarousel({
                loop            : true,
                items           : 3,
                autoplay        : false,
                autoplayTimeout : 6000,
                animateOut      : 'fadeOut',
                dots            : false,
                nav             : true,
                navText         : ['<i class="icon-left"></i>', '<i class="icon-right"></i>'],
                margin          : 20,
                responsive      : {
                    0: {
                        items: 1,
                        margin: 10
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    }
                }
            });
        });

        // Carousel parceiros
        $('[data-component=carousel-parceiros]').each(function(index, el) {
            $(this).addClass('owl-carousel');
            $(this).owlCarousel({
                loop            : true,
                items           : 3,
                autoplay        : false,
                autoplayTimeout : 3000,
                animateOut      : 'fadeOut',
                navText         : ['<i class="icon-left"></i>', '<i class="icon-right"></i>'],
                dots            : true,
                margin          : 120,
                responsive      : {
                    0: {
                        items: 2,
                        nav: true,
                        margin: 20,
                        autoplay: true
                    },
                    768: {
                        items: 3,
                        margin: 50
                    },
                    992: {
                        items: 3
                    }
                }
            });
        });

        // Active na primeira div nos ensinos
        $('.Tabs .list li:first-child a').addClass('_active');
        $('.Tabs .tab-itens .tab:first-child').addClass('_active');

        // Cookies
        if (localStorage.hasOwnProperty('verify_cookies')) {
            $('.Cookies').addClass('_hide');
        }

        $('.Cookies .Button').click(function(event) {
            event.preventDefault();
            localStorage.setItem('verify_cookies', true);
            $('.Cookies').addClass('_hide');
        });

        // Drop
        $(document).on('click', '[data-component=drop] h4', function(event) {
            event.preventDefault();
            $(this).parent().toggleClass('_active');
        });

        $('.links .selected').click(function(event) {
            $('.links #dropdown').toggleClass('_hide');
        });

        var d = new Date();
        d.setDate(d.getDate() + 1);

        $('[data-toggle="datepicker"]').datepicker({
            language: 'pt-BR',
            startDate: d
        });

        // open PDF popup
        $(document).ready(function() {
            $('.pdf-popup1').magnificPopup({
                type: 'iframe'
            });
            $('.pdf-popup2').magnificPopup({
                type: 'iframe'
            });
        });
    });
});